/* eslint-disable react/prefer-stateless-function */
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import OPENAI_WIDGET from '../../constants/srcTypes';
import context from './context';
import './WidgetPageFooter.scss';

class WidgetPageFooter extends React.Component {
  static contextTypes = context;

  render() {
    const {
      children,
      className,
      previewMode,
      sourceId,
      shadow,
    } = this.props;
    const isOpenAiWidget = sourceId === OPENAI_WIDGET;

    return (
      <div className={cx('WidgetPageFooter', 'WidgetPageFooter-fixed', className, {
        'WidgetPageFooter-fixed--openai': isOpenAiWidget,
      })}
      >
        {previewMode && <div className="WidgetPageFooter--disabled" />}
        {children}
        <div className={cx('WidgetPageFooter__shadow', { 'WidgetPageFooter__shadow-on': shadow })} />
      </div>
    );
  }
}

WidgetPageFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  previewMode: PropTypes.bool,
  className: PropTypes.string,
  sourceId: PropTypes.string,
  shadow: PropTypes.bool,
};

WidgetPageFooter.defaultProps = {
  children: null,
  className: undefined,
  previewMode: false,
  sourceId: undefined,
  shadow: false,
};

const mapStateToProps = ({ resyRouter }) => ({
  sourceId: resyRouter?.sourceId,
});

export { WidgetPageFooter as ComponentUnderTest };
export default connect(mapStateToProps)(WidgetPageFooter);
